import { KeyboardEvent } from "react";
import { NavLink } from "react-router-dom";
import { Formik, Form, FastField } from "formik";
import { TextField } from "formik-material-ui";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import * as Yup from "yup";

import AuthLayout from "../../themes/layouts/Auth";
import useButtonStyles from "../../styles/Buttons";
import useSharedStyles from "../../styles/Shared";
import { InputLabel } from "@mui/material";

type Props = {
  onSubmit: (values: ResendActivationVars, formikBag: unknown) => void | Promise<unknown>;
};

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Please enter a valid email").required("Email is required"),
});

const ResendActivationForm: React.FC<Props> = ({ onSubmit }) => {
  const { classes: buttonClasses, cx } = useButtonStyles();
  const { classes: sharedClasses } = useSharedStyles();

  return (
    <AuthLayout>
      <Typography variant="h1">Resend activation email</Typography>
      <Typography variant="subtitle1">
        Back to{" "}
        <Link component={NavLink} to="/user/login">
          Sign in
        </Link>
      </Typography>
      <Formik<ResendActivationVars>
        validationSchema={validationSchema}
        initialValues={{ email: "" }}
        onSubmit={onSubmit}
      >
        {({ handleSubmit }) => (
          <Form>
            <Box className={sharedClasses.fieldBox}>
              <InputLabel>Email</InputLabel>
              <FastField
                component={TextField}
                name="email"
                placeholder="Email"
                fullWidth
                variant="outlined"
                type="email"
                onKeyDown={(e: KeyboardEvent<HTMLDivElement>) => {
                  if (e.key === "Enter") handleSubmit();
                }}
                autoFocus
              />
            </Box>
            <Box display="flex" alignItems="center" justifyContent="flex-end" pt={2}>
              <Button type="submit" className={cx(buttonClasses.blue, buttonClasses.large, buttonClasses.iconButton)}>
                Reset
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </AuthLayout>
  );
};

export default ResendActivationForm;
